type CheckoutStatus = {
    sessionId: string;
    status: string | null;
};

type GetCheckoutStatus = (sessionId: string) => Promise<CheckoutStatus>;
type Wait = (milliseconds: number) => Promise<void>;
type ShouldContinue = () => boolean;

const CHECKOUT_STATUS_ATTEMPTS = 4;
const CHECKOUT_STATUS_DELAYS_MS = [1000, 2000, 4000];

export const waitForCheckoutStatusRetry: Wait = (milliseconds) =>
    new Promise((resolve) => {
        window.setTimeout(resolve, milliseconds);
    });

export const pollCheckoutStatus = async (
    sessionId: string | null,
    getStatus: GetCheckoutStatus,
    wait: Wait,
    shouldContinue: ShouldContinue = () => true,
): Promise<boolean> => {
    if (!sessionId || !shouldContinue()) return false;

    const poll = async (attempt: number): Promise<boolean> => {
        try {
            const result = await getStatus(sessionId);
            if (!shouldContinue()) return false;
            if (result.status === 'completed') return true;
            if (result.status !== 'pending' || attempt >= CHECKOUT_STATUS_ATTEMPTS - 1) return false;
            await wait(CHECKOUT_STATUS_DELAYS_MS[attempt]);
            if (!shouldContinue()) return false;
            return poll(attempt + 1);
        } catch {
            return false;
        }
    };

    return poll(0);
};
